// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip-container {
  position: relative;
  /* Ensure the tooltip positions itself relative to this container */
  /* display: inline-block; */
}

.tooltip-text {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.4s ease, transform 0.6s ease; /* Add transition for opacity and transform */
  transform: scale(0.95); /* Start slightly smaller */
  position: fixed;
  z-index: 1000;
  bottom: 160px;
  /* Adjust as needed for spacing */
  left: 10px;
  /* Center horizontally */
  /* Center the tooltip */
  background-color: #f1f1f3;
  /* Match the background color used in other components */
  color: #333;
  /* Text color consistent with other components */
  text-align: center;
  padding: 10px;
  /* Consistent padding */
  border-radius: 10px;
  /* Match the border-radius used in other components */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  /* Subtle shadow for depth */
  /* opacity: 0; */
  transition: opacity 0.3s ease, visibility 0.3s ease;
  /* Smooth transition for visibility */
  white-space: nowrap;
  /* Prevent line breaks */
  overflow: hidden;
  /* Hide overflow */
  text-overflow: ellipsis;
  /* Add ellipsis for overflow text */
  width: auto;
  /* Allow width to adjust based on content */
  max-width: 350px;
  /* Set a maximum width to prevent it from being too wide */
}

.tooltip-container:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
  transform: scale(1.05); /* Slightly enlarge on hover */
}
`, "",{"version":3,"sources":["webpack://./src/components/Tooltip/Tooltip.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mEAAmE;EACnE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kDAAkD,EAAE,6CAA6C;EACjG,sBAAsB,EAAE,2BAA2B;EACnD,eAAe;EACf,aAAa;EACb,aAAa;EACb,iCAAiC;EACjC,UAAU;EACV,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;EACzB,wDAAwD;EACxD,WAAW;EACX,gDAAgD;EAChD,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qDAAqD;EACrD,yCAAyC;EACzC,4BAA4B;EAC5B,gBAAgB;EAChB,mDAAmD;EACnD,qCAAqC;EACrC,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,mCAAmC;EACnC,WAAW;EACX,2CAA2C;EAC3C,gBAAgB;EAChB,0DAA0D;AAC5D;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,sBAAsB,EAAE,8BAA8B;AACxD","sourcesContent":[".tooltip-container {\n  position: relative;\n  /* Ensure the tooltip positions itself relative to this container */\n  /* display: inline-block; */\n}\n\n.tooltip-text {\n  visibility: hidden;\n  opacity: 0;\n  transition: opacity 0.4s ease, transform 0.6s ease; /* Add transition for opacity and transform */\n  transform: scale(0.95); /* Start slightly smaller */\n  position: fixed;\n  z-index: 1000;\n  bottom: 160px;\n  /* Adjust as needed for spacing */\n  left: 10px;\n  /* Center horizontally */\n  /* Center the tooltip */\n  background-color: #f1f1f3;\n  /* Match the background color used in other components */\n  color: #333;\n  /* Text color consistent with other components */\n  text-align: center;\n  padding: 10px;\n  /* Consistent padding */\n  border-radius: 10px;\n  /* Match the border-radius used in other components */\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  /* Subtle shadow for depth */\n  /* opacity: 0; */\n  transition: opacity 0.3s ease, visibility 0.3s ease;\n  /* Smooth transition for visibility */\n  white-space: nowrap;\n  /* Prevent line breaks */\n  overflow: hidden;\n  /* Hide overflow */\n  text-overflow: ellipsis;\n  /* Add ellipsis for overflow text */\n  width: auto;\n  /* Allow width to adjust based on content */\n  max-width: 350px;\n  /* Set a maximum width to prevent it from being too wide */\n}\n\n.tooltip-container:hover .tooltip-text {\n  visibility: visible;\n  opacity: 1;\n  transform: scale(1.05); /* Slightly enlarge on hover */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
